import { useMutation, useQuery } from 'react-query'
import axios from 'axios'
import { DocumentLink, Document, StorePdfCalculationResult } from 'BrokerTsLib/src/dtos'
import { baseUrl, GenericQueryOptions } from '.'
import { useApp } from './useApp'
import { Product } from 'BrokerTsLib/src/enums'
import { longStaleTime } from 'BrokerTsLib/src/hooks'

const carkulkaUrl = process.env.REACT_APP_CARKULKA_URL
const documentVehicleUrl = process.env.REACT_APP_DOCUMENT_VEHICLE_API
const documentTravelUrl = process.env.REACT_APP_DOCUMENT_TRAVEL_API
const documentPropertyUrl = process.env.REACT_APP_DOCUMENT_PROPERTY_API
// const url = `${baseUrl}/${documentVehicleUrl}`

export const useUrl = () => {
  const { product } = useApp()

  let url: string | undefined = ''

  switch (product) {
    case Product.TravelInsurance: url = documentTravelUrl; break;
    case Product.PropertyInsurance: url = documentPropertyUrl; break;
    default: url = documentVehicleUrl; break;
  }

  return `${baseUrl}/${url}`
}

export const useGetDocuments = (offerId: number, options?: GenericQueryOptions<DocumentLink[]>) => {
  return useQuery(['getDocuments', offerId], () =>
    axios.get<DocumentLink[]>(`${carkulkaUrl}/Reports/GetDocuments?offerId=${offerId}`, {
      withCredentials: true,
    }), options)
}

export const useGetOfferDocuments = (offerId: number, options?: GenericQueryOptions<Document[]>) => {
  const url = useUrl()
  return useQuery(
    ['GetOfferDocuments', offerId],
    () => axios.get<Document[]>(`${url}/GetOfferDocuments?offerId=${offerId}`),
    {
      refetchOnWindowFocus: false,
      retry: false,
      ...options
    },
  )
}

export const useStorePdfCalculation = (paramsId: string, options?: GenericQueryOptions<StorePdfCalculationResult>) => {
  const url = useUrl()
  return useMutation(() => axios.get<StorePdfCalculationResult>(`${url}/SaveOffersPdf?paramsId=${paramsId}`, { withCredentials: true }))
}

export const useGetBrandLogo = (categoryId?: number | null, brand?: string | null, options?: GenericQueryOptions<string>) => {
  const url = useUrl()

  return useQuery(
    ['GetBrandLogo', categoryId, brand],
    () => axios.get<string>(`${url}/GetBrandLogoBase64?categoryId=${categoryId}&brand=${brand}`),
    {
      staleTime: longStaleTime,
      refetchOnMount: false,
      retry: false,
      ...options
    },
  )
}


export type VehicleIdentificationLinkPropsDto = {
  paramsId?: string
  spz?: string | null
  vin?: string | null
  vehicleId?: string
}

export const getVehicleIdentificationLink = (data: VehicleIdentificationLinkPropsDto) => {
  const url = `${baseUrl}/${documentVehicleUrl}`

  let idParam = ''
  if (data.paramsId) idParam = `&id=${data.paramsId}`
  let vinParam = ''
  if (data.vin) vinParam = `&vin=${data.vin}`
  let spzParam = ''
  if (data.spz) spzParam = `&registrationMark=${data.spz}`

  return `${url}/GetIdentificatedVehiclePdf?vehicleId=${data.vehicleId}${vinParam}${spzParam}${idParam}`
}

export type SendHelpdeskEmailResponse = {
  success: boolean
  text: string
}

export type SendHelpdeskEmailRequest = {
  name: string
  email: string
  phone: string
  subject: string
  //questionType: string
  message: string
  //files?: FileList
  product?: number
}

export const sendHelpdeskEmail = (data: SendHelpdeskEmailRequest) => {
  const url = `${baseUrl}/${documentVehicleUrl}`
  return axios.post<SendHelpdeskEmailResponse>(`${url}/SendHelpdeskEmail`, data, {
    withCredentials: true,
  })
}
